import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {TranslatePipe, TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-footer',
    imports: [
        TranslatePipe
    ],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
  changeDetection : ChangeDetectionStrategy.OnPush
})
export class FooterComponent {
  protected readonly translateService = inject(TranslateService);
}
